var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-192.000000, -154.000000)",
    fill: "#1C2154",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,157.86 L207.4,154 L206.11,155.53 L210.71,159.39 L212,157.86 Z M197.88,155.53 L196.6,154 L192,157.85 L193.29,159.38 L197.88,155.53 Z M202,156.14 C197.03,156.14 193,160.17 193,165.14 C193,170.11 197.02,174.14 202,174.14 C206.97,174.14 211,170.11 211,165.14 C211,160.17 206.97,156.14 202,156.14 Z M202,172.14 C198.13,172.14 195,169.01 195,165.14 C195,161.27 198.13,158.14 202,158.14 C205.87,158.14 209,161.27 209,165.14 C209,169.01 205.87,172.14 202,172.14 Z M200.54,166.67 L198.41,164.54 L197.35,165.6 L200.53,168.78 L206.53,162.78 L205.47,161.72 L200.54,166.67 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon-alarm.f987ca87.svg";
export { ForwardRef as ReactComponent };